import { render } from "./q2.vue?vue&type=template&id=40e1ce9a&scoped=true"
import script from "./q2.vue?vue&type=script&lang=js"
export * from "./q2.vue?vue&type=script&lang=js"

import "./q2.vue?vue&type=style&index=0&id=40e1ce9a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e1ce9a"],['__file',"cartridges/int_guidedProductFinder/cartridge/client/default/js/components/questionTemplates/q2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40e1ce9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40e1ce9a', __exports__)) {
    api.reload('40e1ce9a', __exports__)
  }
  
  module.hot.accept("./q2.vue?vue&type=template&id=40e1ce9a&scoped=true", () => {
    api.rerender('40e1ce9a', render)
  })

}


export default __exports__